<template>
  <span>
    <Dialog
      class="test-box"
      header="Enviar Nota Fiscal por E-mail"
      :visible.sync="showEnviarEmail"
      :modal="true"
      :closable="false"
    >
      <div styyle="margin-let: 15px;margin-right: 15px;">
        <div id="topo" class="row">
          <div class="col-md-12 mb-2">
            <label for="tipoTomador">E-mails (separe com ponto e vírgula ( ; )): *</label>
            <span class="p-fluid">
              <InputText v-model="emails" type="text" />
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 mb-2">
            <label for="tipoTomador">Comentários:</label>
            <span class="p-fluid">
              <textarea v-model="comentarios" type="text" />
            </span>
          </div>
        </div>
      </div>

      <hr />

      <div styyle="margin-let: 15px;margin-right: 15px;">
        <div class="row">
          <div>
            <Button
              @click="enviarEmailDaps()"
              href="#topo"
              type="button"
              label="Enviar"
              class="p-button-primary mr-2 p-button-success"
              icon="pi pi-check"
              :disabled="loading"
            />
          </div>

          <div>
            <Button
              @click="showEnviarEmail = false"
              type="button"
              label="Fechar"
              class="p-button-primary mr-2 p-button-danger"
              icon="pi pi-times"
            />
          </div>
        </div>
      </div>
    </Dialog>
  </span>
</template>

<script>
import DapsService from "@/services/nfse/daps.service";

export default {
  name: "EnviarEmailNotaFiscal",

  created() {
    this.$root.$on("daps:enviarEmail", id => {
      this.idDaps = id;
      this.exibirDialogCancelarNota();
    });
  },

  data() {
    return {
      showEnviarEmail: false,
      idDaps: null,
      emails: null,
      comentarios: null
    };
  },

  methods: {
    exibirDialogCancelarNota() {
      this.showEnviarEmail = true;
    },

    enviarEmailDaps() {
      console.log("chamou");
      if (this.emails) {
        this.$parent.processando(true);
        this.$parent.erros = [];

        if (this.emails)
          DapsService.enviarPorEmail(this.idDaps, this.emails, this.comentarios)
            .then(
              data => {
                console.log(data);
                this.$root.$emit("alert:success", "O E-mail foi enviado!");
              },
              error => {
                this.$parent.erros.push(...error.response.data);
                console.log(error.response);
              }
            )
            .then(() => {
              this.showEnviarEmail = false;
              this.$parent.processando(false);
            });
      } else {
        this.$root.$emit(
          "alert:warn",
          "É necessário informar pelo menos um e-mail!"
        );
      }
    }
  },

  computed: {
    loading() {
      return this.$parent.loading;
    }
  }
};
</script>

<style scoped>
textarea {
  width: 100%;
  border-radius: 12px;
  height: 100px;
  padding-left: 8px;
}
</style>